<template>
	<div>
		<transition name="fade">
			<div v-if="loading" id="preloader">
				<div id="status"></div>
			</div>
		</transition>
		<header>
			<nav class="container">
				<div class="row">
					<div class="col-xs-5 top-nav-container"/>
					<div class="col-xs-7 logo-container-head">
						<img class="img-responsive logo-head" src="@/assets/images/iadsa-logo.svg" alt="IADSA">
					</div>
				</div>
			</nav>
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-11 col-lg-9">
						<div class="home-page-title login-title-padding">
							FORGOTTEN<br/>
							YOUR PASSWORD?
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-sm-8 col-md-7 col-lg-6">
						<div class="intro-text-white">
							In order to reset your password, please enter
							your account email address and we'll email you
							a link to set a new password.
						</div>
					</div>
					<div class="col-xs-12 col-sm12 col-md-4 col-md-offset-1">
						<div class="form-group">
							<label for="email" class="form-label sr-only">Email</label>
							<input
								v-model="email_address"
								class="form-control"
								name="email"
								type="email"
								placeholder="Email"
								required
							>
						</div>
						<div class="left-center-xs">
							<b-btn class="btn btn-primary" type="submit" @click="reset">
								Request password reset
							</b-btn>
							<div>
								<router-link class="btn btn-clear" to="/login" tag="a">Back to login</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
		<footer class="page-footer page-footer-login">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-8">
						<p class="left-center-xs">
							<a href="https://www.iadsa.org/disclaimer" target="_blank">Disclaimer</a>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
							<a href="https://www.iadsa.org/privacy" target="_blank">Privacy Policy</a>
							<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
							<br class="visible-xs" />
							<br class="visible-xs" />
							<a href="https://www.iadsa.org/" target="_blank">iadsa.org</a>
							<br />
							<br />
							<small>
								© {{ currentYear }} IADSA. All rights reserved.
								<br class="visible-xs visible-sm" />
								Built on BubbleAMS, <a href="http://www.bubblegate.co.uk" target="_blank">by Bubblegate</a>
								<br />
								<br class="visible-xs visible-sm" />
								Gridiron Building, One Pancras Square,
								<br class="visible-xs visible-sm" />
								London, N1C&nbsp;4AG, United Kingdom
							</small>
						</p>
					</div>
					<div class="hidden-xs col-sm-4">
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<style lang="less">
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

<script>
import moment from 'moment';
import { Notification } from 'uiv';

export default {
	created() {
		this.runLoader();
	},
	data() {
		return {
			email_address: null,
			loading: false
		};
	},
	methods: {
		async reset() {
			try {
				this.$router.push({ path: '/login' });
				await this.$axios.post('/reset-password', { email_address: this.email_address });
				Notification.notify({
					type: 'info',
					title: 'Password reset email sent.',
					duration: 10000
				});
			} catch (e) {
				Notification.notify({
					type: 'warning',
					title: 'Could not reset password.',
					content: e.response ? e.response.data.message : 'Invalid email',
					duration: 3000
				});
			}
		},
		runLoader() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		}
	},
	computed: {
		currentYear() {
			return moment().format('YYYY');
		}
	}
};
</script>
